import { CadastroService } from 'app/shared/services/cadastro.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { AVISAR_OPTIONS, CadastroOcorrencia, CadastroOcorrenciaAvisar } from 'app/shared/interfaces/cadastro-ocorrencia';

export const OCORRENCIA_MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-ocorrencia-popup',
  templateUrl: './ocorrencia-popup.component.html',
  styleUrls: ['./ocorrencia-popup.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: OCORRENCIA_MY_FORMATS },
  ],
})
export class OcorrenciaPopupComponent implements OnInit {

  public ocorrenciaForm: FormGroup;
  avisarOptions: CadastroOcorrenciaAvisar[] = AVISAR_OPTIONS;
  cadastroId: number;
  isSaving = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OcorrenciaPopupComponent>,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private loader: AppLoaderService,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit() {
    this.cadastroId = this.data.cadastroId;
    this.buildItemForm(this.data.payload, this.data.isNew);
  }

  buildItemForm(ocorrencia: CadastroOcorrencia, isNew: boolean) {
    const payload = (ocorrencia ?? {}) as CadastroOcorrencia;
    const hoje = moment();

    this.ocorrenciaForm = this.fb.group({
      id: [payload.id],
      uuid: [payload.uuid],
      dataOcorrencia: [payload.dataOcorrencia ? moment(payload.dataOcorrencia) : (isNew ? hoje : null), [Validators.required]],
      ocorrencia: [payload.ocorrencia, [Validators.required]],
      avisar: [payload.avisar ?? (isNew ? this.findAvisar('3') : this.findAvisar('9'))],
      dataAvisarInicial: [payload.dataAvisarInicial ? moment(payload.dataAvisarInicial) : (isNew ? hoje.clone() : null)],
      dataAvisarFinal: [payload.dataAvisarFinal ? moment(payload.dataAvisarFinal) : (isNew ? hoje.clone() : null)],
      status: [payload.status],
    });
  }

  findAvisar(codigo: string): CadastroOcorrenciaAvisar {
    return this.avisarOptions.find(a => a.codigo === codigo) ?? this.avisarOptions[this.avisarOptions.length - 1];
  }

  compareAvisar = (a: CadastroOcorrenciaAvisar, b: CadastroOcorrenciaAvisar): boolean => {
    return a && b ? a.codigo === b.codigo : a === b;
  }

  private toDateStr(value: any): string | undefined {
    return value ? moment(value).format('YYYY-MM-DD') : undefined;
  }

  save() {
    if (this.ocorrenciaForm.invalid) {
      this.ocorrenciaForm.markAllAsTouched();
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !',
        message: 'Preencha os campos obrigatórios (Data e Ocorrência), verifique!', error: true
      });
      return;
    }

    const form = this.ocorrenciaForm.value;
    const payload: CadastroOcorrencia = {
      id: form.id,
      uuid: form.uuid,
      dataOcorrencia: this.toDateStr(form.dataOcorrencia),
      ocorrencia: form.ocorrencia,
      avisar: form.avisar,
      dataAvisarInicial: this.toDateStr(form.dataAvisarInicial),
      dataAvisarFinal: this.toDateStr(form.dataAvisarFinal),
      status: form.status,
    };

    this.isSaving = true;
    this.loader.open();
    this.cadastroService.saveOrUpdateOcorrencia(this.cadastroId, payload).subscribe(
      (val: CadastroOcorrencia) => {
        this.isSaving = false;
        this.loader.close();
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, Ocorrência salva com sucesso!', error: false
        });
        this.dialogRef.close(val ?? true);
      },
      (err: any) => {
        this.isSaving = false;
        this.loader.close();
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR OCORRÊNCIA, VERIFIQUE',
          message: err?.error?.status ?? err?.error?.message ?? 'Erro inesperado ao salvar ocorrência.', error: true
        });
      });
  }

  close() {
    this.dialogRef.close();
  }

}
